<div class="type-main">
  <div class="type-main-page">
    <div class="type-cross-container" (click)="cancel()">
      <img class="type-cross-img" src="assets/general/cross-gray.svg" />
    </div>
    <div
      *ngIf="dataIsReady"
      class="type-holder"
      style="top: 0; height: calc(100% - 96px)"
    >
      <div class="type-banner">
        <img src="{{ generateShared.selectedDietType?.image }}" />
        <div class="type-selected-bottom-box">
          <div class="type-selected-predefined-diet-name">
            {{ generateShared.selectedDietType.name }}
          </div>
          <div class="type-selected-predefined-diet-duration">
            {{ generateShared.selectedDietType.days }} روز
          </div>
        </div>
      </div>
      <div class="type-selected-predefined-diet-title">توضیح</div>
      <div class="type-selected-predefined-diet-description">
        {{ generateShared.selectedDietType.description }}
      </div>
    </div>
    <div *ngIf="dataIsReady" class="type-submit" (click)="start()">شروع</div>
  </div>
</div>
